var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"d-back-button button",class:_vm.buttonClass,attrs:{"title":"Back"},on:{"click":function($event){return _vm.goBack()}}},[_c('DuiIconArrowLeft',{class:_vm.vm.iconClass})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }